// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"testimonials_wrapper__Jei5h","container":"testimonials_container__eV_ZG","list":"testimonials_list__Bi46M","card":"testimonials_card__hvSWf"};